import {
    COUNTRY_MAPPING_SUCCESS,
    COUNTRY_MAPPING_FAILED,
    RESET_COUNTRY_MAPPING,
    LOADING_COUNTRY_MAPPING,
    NETWORK_ERROR_COUNTRY_MAPPING
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case COUNTRY_MAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case COUNTRY_MAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case LOADING_COUNTRY_MAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_COUNTRY_MAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_COUNTRY_MAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
